const state = {
  showHomeHeader: false
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js